import apiService from "./../../../../server";
import { ORG_USER, ORG_USERS } from "../api";

export function fetchOrgUsers(page = 0, size = 20) {
    return apiService.get(ORG_USERS, { params: { page, size } });
}

export function createOrgUser(data: object) {
    return apiService.post(ORG_USER, data);
}

export function updateOrgUser(data: object) {
    return apiService.put(ORG_USER, data);
}
